import { getServerRequest } from '@/helpers/serverRequest.helper';
import { store } from '@/store/store';
const httpURL = store.getters.httpURL;

export const cargarUsuariosService = async () => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/usuarios/listado`;
    return await getServerRequest(url, config);
}

export const cargarUsuariosPaginadosService = async (page, search) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/usuarios/${page}/${search}`;
    return await getServerRequest(url, config);
}
